// extracted by css-extract-rspack-plugin
export default {"pendingBody":"DescriptionEditor-module__pendingBody__wPPFj"};